import React from 'react';

const VideoWatch = ({ presentations, eventSlug }) => {
  return <div className="upload-speaker-container b-shadow m-t-30">
    {
      presentations.filter(p => p.video)
        .length === 0 && <i>No videos available yet</i>
    }
    {
      presentations
        .filter(p => p.video)
        .map(p => <div className="link-row">
          <a className="btn btn-primary btn-lg" target="_blank" href={
            `${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${eventSlug}/${p._id}`
          }>Watch Video</a>
          <h5>{p.name}</h5>
        </div>)
    }
  </div>
}

export default VideoWatch;
